import { useTheme } from "@emotion/react";
import { Button, Stack, Typography } from "@mui/material";
import CenteredText from "components/CenteredText";
import Page from "components/Page";

import BgAreaX from "assets/images/areax_back.png";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";
import AreaXLogo from "assets/images/areax_logo.svg";
import { Box } from "@mui/system";
import { useState } from "react";
import SimpleDialog from "components/SimpleDialog";
import { useLazyRemote } from "lib/useRemote";

const ScopriAreaX = () => {
	const history = useHistory();
	const theme = useTheme();
	const [open, setOpen] = useState(false);
	const [current, setCurrent] = useState(undefined);
	const {runCommand: runCommandAreaX} = useLazyRemote({command: "DOPO_SITO"});
	const {runCommand: runCommandPrenotazione} = useLazyRemote({command: "DOPO_PRENOTAZIONE"});

	const openModal = (dest) => {
		setCurrent(dest);
		setOpen(true);
	};

	const onClose = () => {
		setOpen(false);
		setCurrent(undefined);
	};

	const onConfirm = (current) => {
		let win;
		switch (current) {
			case "areax":
				win = window.open("http://areax.info", "_blank");
				win.focus();
				runCommandAreaX();
				break;
			case "ticketOne":
				win = window.open("https://www.ticketone.it/artist/area-x/", "_blank");
				win.focus();
				runCommandPrenotazione();
				break;
			default:
				break;
		}
	};

	return (<Page syncNavCommand="AREAX_SLIDE" audioFile="/sounds/1.mp3">
		<Stack spacing={1} sx={{
			display: "flex", flex: 1
		}}>
			<div style={{backgroundImage: `url(${BgAreaX})`, height: "15rem", backgroundSize: "cover"}}>
				<Box sx={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}}>
					<img src={AreaXLogo} alt="Area X" style={{width: "60%"}}/>
				</Box>
			</div>
			<Stack sx={{
				display: "flex", flex: 1
			}}>
				<CenteredText>
					<Button variant="contained" color="primary"
									style={{width: "100%"}} onClick={() => history.push("/areax")}>
						Cos’è lo spazio Area X
					</Button>
				</CenteredText>
				<CenteredText>
					<Button variant="contained" color="primary"
									style={{width: "100%"}} onClick={() => openModal("areax")}>
						Visita il nostro sito
					</Button>
				</CenteredText>
				<CenteredText>
					<Button variant="contained" color="primary"
									style={{width: "100%"}} onClick={() => openModal("ticketOne")}>
						Prenota la tua visita in Area X
					</Button>
				</CenteredText>
				<CenteredText>
					<Button variant="contained" color="primary"
									style={{width: "100%"}} onClick={() => history.push("/contatti_areax")}>
						Rimani in contatto con noi
					</Button>
				</CenteredText>
				<CenteredText>
					<Link to="/scelta_iniziale">
						<Typography variant="h6"
												color={theme.palette.primary.main}
												sx={{textDecoration: "underline"}}>
							Torna alla Home Page
						</Typography>
					</Link>
				</CenteredText>
			</Stack>
		</Stack>
		<SimpleDialog
			open={open}
			title={"Stai per lasciare questa pagina per visitare un sito esterno, non tardare! Potresti perdere la priorità sul robot."}
			onConfirm={() => {
				onConfirm(current);
			}}
			onClose={() => onClose()}
		>
			<Typography>Ricordati di tornare su questa pagina
				per continuare l’esperienza con il
				robot Pepper.</Typography>
		</SimpleDialog>
	</Page>);
};
export default ScopriAreaX;